// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Caption-module--bx--text-truncate--end--1fihr";
export var bxTextTruncateFront = "Caption-module--bx--text-truncate--front--AVEOQ";
export var caption = "Caption-module--caption--AvVvB";
export var captionResponsive = "Caption-module--caption-responsive--XjLUS";